import * as services from '@services/index';
import {
  IPatientInfo,
  IDiseaseInfo,
  IDiseaseVo,
  IDrugInfoVO,
  ISearchDrugVo
} from '@/schemas/prescription';
import { IShippingAddress } from '@/schemas/med';

interface IState {
  // 当前正在编辑的处方订单参数
  currentUpdateOrderId?: number;
  currentUpdatePrescroptionId?: number;

  clinicalDiagnosis: IDiseaseVo[]; // 临床诊断
  RPList: IDrugInfoVO[]; // 药品列表
  doctorAdvice: string; // 医嘱

  usage: string; // 用法
  singleDose: string; // 单次剂量单位
  singleDoseNum: number; // 单次剂量
  drugUseFrequency: string; // 用药频次
  prescribingNum: number; // 开药数量
  prescribingUnit: string; // 开药单位
  medicationDays: number; // 用药天数

  diseaseInfo: IDiseaseInfo;
  patientInfo: IPatientInfo;
  shippingAddress: IShippingAddress;
  selectdDrug: ISearchDrugVo;
  selectdDrugID: string[];
}

const initState: IState = {
  clinicalDiagnosis: [],
  RPList: [],
  doctorAdvice: '',
  usage: '',
  singleDose: '',
  singleDoseNum: 0,
  drugUseFrequency: '',
  prescribingNum: 0,
  medicationDays: 0,
  prescribingUnit: '',

  diseaseInfo: {},
  patientInfo: {} as IPatientInfo,
  shippingAddress: {} as IShippingAddress,
  selectdDrug: {} as ISearchDrugVo,
  selectdDrugID: []
};

const prescription = {
  state: initState,

  reducers: {
    updateState<K extends keyof IState>(
      state: IState,
      payload: {
        [key: string]: IState[K];
      }
    ): IState {
      return {
        ...state,
        ...payload
      };
    },
    updateShippingAddress(state: IState, payload: IShippingAddress) {
      return {
        ...state,
        shippingAddress: payload
      };
    }
  },

  effects: (_dispatch) => ({
    async getPatientInfo(orderId) {
      try {
        const res = await services.prescription.getPatientInfo(orderId);
        this.updateState({
          patientInfo: { ...res.patientInfo },
          diseaseInfo: { ...res.diseaseInfo }
        });
        return res;
      } catch (e) {
        // console.log('拉取患者信息错误', e);
        return Promise.reject(e);
      }
    }
  })
};

export default prescription;
